/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.to-string.js";
export default {
  props: {
    mode: {
      required: true,
      type: String
    }
  },
  data: function data() {
    return {
      name: 'mixin',
      screenWidth: 375,
      baseScreenWidth: 375,
      baseFontSize: 100,
      baseFz: 100,
      // 常量  375px屏幕下的元素基准字体大小
      defaultImg: 'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg=='
    };
  },
  created: function created() {
    //根据屏宽计算baseFontSize
    var screenWidth = this.isPc ? 320 : document.documentElement.clientWidth;
    this.screenWidth = screenWidth;
    this.baseFontSize = this.baseFontSize / this.baseScreenWidth * screenWidth;
  },
  mounted: function mounted() {
    if (this.isPc) {
      this.$el.style.width = this.screenWidth + 'px';
    }

    this.$el.style.fontSize = this.baseFontSize + 'px';
    this.$el.style.marginLeft = 'auto';
    this.$el.style.marginRight = 'auto';
    var actualFontSize = parseFloat(window.getComputedStyle(this.$el)['font-size']);

    if (actualFontSize != this.baseFontSize) {
      var actualRem = this.baseFontSize / (actualFontSize / this.baseFontSize);
      this.$el.style.fontSize = actualRem + 'px';
    }

    this.$el.style.backgroundColor = '#fff';

    var _this = this; // if(ResizeObserver){
    //     let objResizeObserver = new ResizeObserver(function (entries) {
    //         setTimeout(() => {
    //             _this.calcFn();
    //             _this.calc && _this.calc();
    //         },200)
    //     });
    //     // 观察文本域元素
    //     objResizeObserver.observe(this.$el);
    // }

  },
  computed: {
    isPc: function isPc() {
      return this.mode === "pc";
    }
  },
  methods: {
    calcFn: function calcFn() {
      var screenWidth = this.isPc ? 320 : document.documentElement.clientWidth;
      this.screenWidth = screenWidth;

      if (this.isPc) {
        this.$el.style.width = this.screenWidth + 'px';
      }

      this.baseFontSize = this.baseFz / this.baseScreenWidth * screenWidth;
      this.$el.style.fontSize = this.baseFontSize + 'px';
      this.$el.style.marginLeft = 'auto';
      this.$el.style.marginRight = 'auto';
      var actualFontSize = parseFloat(window.getComputedStyle(this.$el)['font-size']);

      if (actualFontSize != this.baseFontSize) {
        var actualRem = this.baseFontSize / (actualFontSize / this.baseFontSize);
        this.$el.style.fontSize = actualRem + 'px';
      }

      this.$el.style.backgroundColor = '#fff';
    },
    clickItem: function clickItem(item, clickIndex, emitName) {
      var componentName = this.$options.name;
      var copmonentData = clickIndex || clickIndex === 0 ? {
        componentName: componentName,
        clickIndex: clickIndex
      } : {
        componentName: componentName
      };

      if (Object.prototype.toString.call(emitName).indexOf('String') > -1) {
        // 必须穿字符串
        item.emitName = emitName; // 用于处理特殊自定义事件,
      } else {
        item.emitName = null;
      }

      var data = Object.assign({}, item, copmonentData); // 跳转相关逻辑暴露方法,提供到外部处理

      this.$emit('clickItem', data);
    }
  }
};